import { useState } from "react";
import { AdminLayout } from "../../components/admin/AdminLayout";
import { TabNavigation } from "../../components/admin/TabNavigation";
import { useUserRole } from "../../hooks/useUserRole";
import { WhatsAppLogsView } from "./AdminWhatsAppLogs";
import { WhatsAppBlockedView } from "./AdminWhatsAppBlocked";
import { MessageSquare, Ban } from "lucide-react";

type TabType = 'logs' | 'geblokkeerd';

export function AdminWhatsApp() {
  const { isAdmin } = useUserRole();
  const [activeTab, setActiveTab] = useState<TabType>('logs');

  const tabs = [
    { id: 'logs', label: 'Logs', icon: MessageSquare },
    ...(isAdmin ? [{ id: 'geblokkeerd', label: 'Geblokkeerd', icon: Ban }] : []),
  ];

  // Safety: if a support user somehow ends up on the blocked tab, fall back to logs
  const safeTab: TabType = activeTab === 'geblokkeerd' && !isAdmin ? 'logs' : activeTab;

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Page header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">WhatsApp</h1>
            <p className="text-gray-600 mt-1">Conversaties en geblokkeerde nummers</p>
          </div>
        </div>

        <TabNavigation
          tabs={tabs}
          activeTab={safeTab}
          onTabChange={(id) => setActiveTab(id as TabType)}
        />

        {safeTab === 'logs' && <WhatsAppLogsView />}
        {safeTab === 'geblokkeerd' && isAdmin && <WhatsAppBlockedView />}
      </div>
    </AdminLayout>
  );
}
